<template>
  <div class="helpCenter">
    <!-- <img src="../../static/img/img.png" alt=""> -->
    <header>
      <div class="header-body">
        <div class="header-left">
          <img :src="dataI.logo" alt="" />
          <span>{{ pageTitle }}</span>
        </div>
        <div class="header-right">
          <span class="item">
            <img src="../../static/img/download2.png" alt="" />
            <a :href="dataI.link" :download="dataI.linkName">下载手册</a>
          </span>
          <span class="item">
            <img src="../../static/img/contact.png" alt="" />
            <span @click="isShow = true">联系我们</span>
          </span>
        </div>
      </div>
    </header>
    <div class="home-body" :style="{ minHeight: leftH }">
      <div class="body-left">
        <!-- {{activeId}} -->
        <el-tree
          class="left-tree"
          :data="dataI.menuArr"
          :props="defaultProps"
          @node-click="nodeClick"
          ref="tree"
        >
          <div
            class="custom-tree-node"
            :class="
              activeId == data.id &&
              (!data.children || data.children.length == 0)
                ? 'active'
                : ''
            "
            slot-scope="{ node, data }"
          >
            <!-- {{data.id}} -->
            <!-- <span v-show="!data.children" @click="nodeEdit(node, data)" class="right-edit"></span> -->
            <span class="node-title" :title="node.label">{{ node.label }}</span>
          </div>
        </el-tree>
      </div>
      <div class="body-right">
        <h2>{{ titleR }}</h2>
        <div
          class="right-content"
          v-html="rightContent"
          @click="rightClick"
        ></div>
        <!-- <div class="right-content">
         <h3><strong><span style="font-size: 10.5pt;"><span style="font-family: 微软雅黑;">年度发展分析</span></span></strong></h3>
        </div> -->
        <!-- <div class="right-content">
          <h3>学科云概述</h3>
          <p>青塔HDI高校全景云数据平台是校级全景指标采集、管理与分析平台，平台集合了数据字典、数据管理和数据分析等多重功能，不仅全面收录了高等教育重要指标数据，而且提供了便利的数据管理工具，并在此基础上构建了全新的可视化数据分析结果，更好的服务于高校发展和数据研究，平台支持本校全面数据分析、跨校对标数据分析、单项指标数据分析、全景数据分析以及智能分析。</p>
          <p>1) 如何科学合理地定义学科的评价体系？</p>
          <p>2) 高校全部学科中，哪些学科值得重点建设？</p>
          <p>3) 本校特定学科的建设方向是什么？</p>
          <img src="../../static/img/img-c.png" alt="">
          <h3>学科云系统架构</h3>
        </div> -->
      </div>
    </div>
    <!-- 联系我们的弹出框 -->
    <el-dialog :visible.sync="isShow" width="397px" class="contact-dialog">
      <div slot="title" class="dialog-title">
        联系我们<img
          src="../../static/img/cancel.png"
          @click="isShow = false"
          alt=""
        />
      </div>
      <div class="dialog-body">
        <div
          class="dialog-body-item"
          v-for="(item, index) in infoArrshow"
          :key="index"
        >
          <span class="item-title">{{ item[0] }}</span>
          <span class="item-content">{{ item[1] }}</span>
        </div>
        <div class="dialog-body-wx">
          <template v-if="isCase">
            <img src="../../static/img/wx.jpg" alt="" />
            <span>微信公众号</span>
          </template>
          <template v-else>
            <img src="../../static/img/wx.png" alt="" />
            <span>企业微信</span>
          </template>
        </div>
      </div>
    </el-dialog>
    <div class="img-dialog" v-show="showBigImg" @click="closeBigImg">
      <img
        :src="imgSrc"
        id="img-dialog-big"
        @mousewheel="scrollFunc"
        alt=""
        :style="{ transform: `scale(${scale})` }"
      />
    </div>
  </div>
</template>

<script>
import service from "../service/demoService";
export default {
  name: "helpCenter",
  data() {
    return {
      isCase: false,
      t: null,
      scale: 1,
      showBigImg: false,
      imgSrc: "",
      leftH: "",
      infoArrC: [
        ["联系电话：", "0571-86686769"],
        ["联系邮箱：", "service@cingta.com"],
        ["企业微信：", "13053090675"],
        ["青塔网：", "WWW.CINGTA.COM"],
      ],
      infoArr: [
        // ['服务QQ：','3522249353（青塔服务）'],
        ["微信公众号：", "cingta-com（青塔）"],
        // ['服务邮箱：','service@cingta.com'],
        ["服务邮箱：", "support@cingta.com"],
        // ['服务电话：','0571-86686769'],
        ["服务电话：", "0571-87608650"],
        // ['公司地址：','浙江省杭州市拱墅区祥园路88号中国智慧信息产业园I幢（2期3号楼）503'],
        [
          "公司地址：",
          "浙江省杭州市拱墅区祥园路88号中国智慧信息产业园I幢（2期3号楼）6楼",
        ],
      ],
      pId: "",
      rightContent: "",
      // `
      //     <h3>学科云概述</h3>
      //     <p>青塔HDI高校全景云数据平台是校级全景指标采集、管理与分析平台，平台集合了数据字典、数据管理和数据分析等多重功能，不仅全面收录了高等教育重要指标数据，而且提供了便利的数据管理工具，并在此基础上构建了全新的可视化数据分析结果，更好的服务于高校发展和数据研究，平台支持本校全面数据分析、跨校对标数据分析、单项指标数据分析、全景数据分析以及智能分析。</p>
      //     <p>1) 如何科学合理地定义学科的评价体系？</p>
      //     <p>2) 高校全部学科中，哪些学科值得重点建设？</p>
      //     <p>3) 本校特定学科的建设方向是什么？</p>
      //     <img src="../../static/img/img-c.png" alt="">
      //     <h3>学科云系统架构</h3>`
      titleR: "",
      activeId: "",
      defaultProps: {
        children: "children",
        label: "title",
      },
      isShow: false,
      dataI: {
        logo: "../../static/img/img.png",
        title: "青塔",
        link: "手册地址",
        linkName: "手册名",
        menuArr: [
          // {
          //   id:"1",
          //   title:"关于平台",
          //   children:[
          //     {
          //       id:'1-1',
          //       title:"总体介绍",
          //     },
          //     {
          //       id:"1-2",
          //       title:"产品架构",
          //     },
          //     {
          //       id:"1-3",
          //       title:"名词解释",
          //     }
          //   ]
          // },
          // {
          //   id:"2",
          //   title:"评价体系",
          //   children:[],
          // }
        ],
      },
    };
  },
  computed: {
    infoArrshow: function () {
      return this.isCase ? this.infoArrC : this.infoArr;
    },
    pageTitle: function () {
      return this.isCase ? this.dataI.project : this.dataI.title;
    },
  },
  watch: {
    $route: "routerChange",
  },
  methods: {
    closeBigImg() {
      this.showBigImg = false;
      this.scale = 1;
      $("body").removeClass("el-popup-parent--hidden");
    },
    rightClick(e) {
      if (e.target.localName === "img") {
        this.imgSrc = e.target.src;
        this.showBigImg = true;
        $("body").addClass("el-popup-parent--hidden");
      }
    },
    leftHeight() {
      var docHeight = $(document).height();
      var winHeight = $(window).height();
      this.leftH = Math.max(docHeight, winHeight) - 100 + "px";
      //  this.leftH = winHeight - 110 + 'px'
    },
    // 获取页面内容方法
    getPageContent() {
      // let data = {
      //   projectId:this.pId,
      //   menuId:this.activeId,
      // }
      let data = {
        id: this.activeId,
      };
      service
        .getpagecontent(data)
        .then((res) => {
          if (res.state == 0) {
            this.rightContent = res.data ? res.data.content : "";
          } else {
            this.open(res.data, "warning");
          }
        })
        .catch((err) => {
          this.open("系统错误", "warning");
        });
    },
    open(str, type) {
      this.$message({
        message: str,
        type: type,
        duration: 800,
      });
    },
    routerChange() {
      /**
       * 路由改变后调用的函数
       * 1、获取路径上的产品id，通过产品id获取到页面上的信息，顶部图标、标题下载手册地址和左侧菜单
       * 2、拿到第一个有页面内容的菜单id,再加上产品id来请求后台获取页面内容
       */
      this.pId = this.$route.query.pId ? this.$route.query.pId : "";
      if (this.pId) {
        service
          .gethelppage(this.pId)
          .then((res) => {
            if (res.state == 0) {
              this.dataI = res.data[0];
              this.isCase =
                this.dataI.project === "青塔数据产品合作案例" ||
                this.dataI.title === "青塔合作案例库";
              console.log(this.dataI);
              document.title = this.pageTitle;
              //判断是否第一项菜单存在二级子菜单
              if (
                this.dataI.menuArr[0].children &&
                this.dataI.menuArr[0].children.length != 0
              ) {
                // 对应判断是否存在三级子菜单
                if (
                  this.dataI.menuArr[0].children[0].children &&
                  this.dataI.menuArr[0].children[0].children.length != 0
                ) {
                  this.activeId =
                    this.dataI.menuArr[0].children[0].children[0].id;
                  this.titleR =
                    this.dataI.menuArr[0].children[0].children[0].title;
                } else {
                  this.activeId = this.dataI.menuArr[0].children[0].id;
                  this.titleR = this.dataI.menuArr[0].children[0].title;
                }
              } else {
                this.activeId = this.dataI.menuArr
                  ? this.dataI.menuArr[0].id
                  : "";
                this.titleR = this.dataI.menuArr
                  ? this.dataI.menuArr[0].title
                  : "";
              }
              this.getPageContent();
            } else {
              this.open(res.data, "warning");
            }
          })
          .catch((err) => {
            this.open("系统错误", "warning");
          });
      }
    },
    nodeClick(data, node, a) {
      /**
       * 树形菜单点击节点后触发的事件
       * 参数data点击的节点所对应的对象数据
       * 参数node为节点对应的node,可以通过这是参数获取到父节点的数据
       * 第三个参数对应这个节点的dom
       */
      if (!data.children || data.children.length == 0) {
        this.titleR = data.title;
        this.activeId = data.id;
        this.getPageContent();
      }
    },
    scrollFunc(e) {
      console.log(e.wheelDelta, e.detail);
      let flag = 0;
      flag = e.wheelDelta ? e.wheelDelta : -e.detail;
      // if (e.wheelDelta) {  //120是放大，120是缩小
      // } else if (e.detail) {   //-3是放大，3是缩小
      // };
      this.t && clearTimeout(this.t);
      console.log(flag);
      this.t = setTimeout(() => {
        let zomm = flag > 0 ? 0.2 : -0.15;
        let num = this.scale + zomm;
        if (num < 2 && num > 0.25) {
          this.scale = num;
        }
      }, 100);
    },
  },
  created() {
    this.routerChange();
  },
  mounted() {
    window.addEventListener("resize", this.leftHeight);
    this.leftHeight();
    let dom = document.getElementById("img-dialog-big");
    if (document.addEventListener) {
      dom.addEventListener("DOMMouseScroll", this.scrollFunc);
    } else {
      dom.onmousewheel = this.scrollFunc;
    }
  },
};
</script>

<style lang="less">
// @import '../../static/less/page.less';
@import "../../static/less/helpCenter.less";
.helpCenter {
  .right-content {
    img {
      cursor: zoom-in;
    }
  }
  .img-dialog {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: zoom-out;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 95%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/helpCenter.vue